import axios from 'axios';
import router from '@/router';
import store from '@/store';

//widthCredentials: true nodig om cookies te kunnen versturen

const httpClient = axios.create({
  withCredentials: true,
  baseURL: import.meta.env.VITE_API,
});

httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // pak uit de error de originele request (door axios in error.config gezet), als dit een 401 is weten we 100% zeker dat dit een authorisatie error  is.
    if (error.response && error.response.status === 401) {
      store.dispatch('modal/setModal', {
        title: 'Login',
        text: `Je bent niet geautoriseerd.`,
        type: 'notification',
      });
      router.push({ name: 'Logout' });
    }
    if (error.response && error.response.status === 404) {
      store.dispatch('modal/setModal', {
        title: 'Bestaat niet',
        text: `Deze pagina bestaat niet.`,
        type: 'notification',
      });
    }
    if (error.response && error.response.status === 403) {
      store.dispatch('modal/setModal', {
        title: 'Je hebt geen toegang hiertoe',
        text: `Je hebt geen rechten voor deze actie`,
        type: 'notification',
      });
    }
    // er is een fout met de request die niet aan een token ligt, kortom er is serverside iets mis.
    return Promise.reject(error);
  }
);

export default httpClient;
